module.exports = __webpack_public_path__ + "media/נעליים.16ce8cfb.mp3";